  //Allow accesibility move with arrows
  export const handleRadioKeyDown = (e, radioRefs, index, callback) => {
    if (e.key === "ArrowRight" || e.key === "ArrowDown") {
      e.preventDefault();
      const nextIndex = (index + 1) % radioRefs.current.length;
      radioRefs.current[nextIndex]?.focus();
      callback?.(nextIndex);
    } else if (e.key === "ArrowLeft" || e.key === "ArrowUp") {
      e.preventDefault();
      const prevIndex = (index - 1 + radioRefs.current.length) % radioRefs.current.length;
      radioRefs.current[prevIndex]?.focus();
      callback?.(prevIndex);
    } else if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      if(callback){
        callback(index);
      }
      //handleOnChangeOrder(sortingKeys[index].id);
    }
  };
